<template>
  <b-textarea :value="value" @input="$emit('input', $event)" ref="input" :state="state"/>
</template>

<script>
import baseInput from './_base'

export default {
  mixins: [baseInput],
}
</script>

<style lang="scss">
.live-input--textarea {
  .form-control {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
}
</style>